import * as types from '../constants/screenConstants';

const initialState = {
  isMobileView: false,
  isTabletView: false,
};

const screenReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_IS_MOBILE_VIEW:
      return {
        ...state,
        isMobileView: payload,
      };
    case types.SET_IS_TABLET_VIEW:
      return {
        ...state,
        isTabletView: payload,
      };
    default:
      return state;
  }
};

export default screenReducer;
